import type { PatientIdentityUrls } from "../../lib/api/generated/sASOnlineClinicBackendAPI.schemas";
import { preferMediaTarget } from "../../lib/mediaAccess";

type IdentityDocumentMedia = {
  frontResourcePath: string | null;
};

export type IdentityRegistrationStatus = {
  insuranceRegistered: boolean;
  identityRegistered: boolean;
  canReserve: boolean;
};

const isDocumentRegistered = (
  media?: IdentityDocumentMedia | null,
): boolean => {
  return Boolean(preferMediaTarget(media?.frontResourcePath));
};

export const resolveIdentityRegistrationStatus = (
  identityUrls?: PatientIdentityUrls | null,
): IdentityRegistrationStatus => {
  const insuranceRegistered = isDocumentRegistered(identityUrls?.insuranceCard);
  const identityRegistered = isDocumentRegistered(
    identityUrls?.identityDocument,
  );

  return {
    insuranceRegistered,
    identityRegistered,
    canReserve: insuranceRegistered && identityRegistered,
  };
};
